export default __webpack_public_path__ + "static/media/EngineeringDams_07.44b4b02b.png";